module.exports = __webpack_public_path__ + "static/media/tl_lock.3c0d9eb7.svg";